<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center" style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s"
                style="font-size: xx-large !important;">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">ENVIRONMENTAL SAFEGUARD</span>
                <span v-else>ENVIRONMENTAL SAFEGUARD</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Environmental Safeguard</span>
                    <span v-else>Environmental Safeguard</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
            <div class="sub-style">
                <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                    MONITORING ENVIRONMENTAL SAFEGUARD
                </h1>
                <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                    SAFEGUARD ENVIRONMENTAL MONITORING
                </h1>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="row" data-wow-delay="0.1s">
                <div class="col-sm-12 text-center wow fadeInUp" data-wow-delay="0.1s">
                    <a class="hitam">
                        <button type="button" class="btn btn-success btn-sm text-white lebar2" data-toggle="tooltip"
                            data-placement="left" title="Unduh excel.." @click="G_tableCSVTabel1('_Environment_')">
                            <i class="fas fa-download"></i>
                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                Unduh Data .xlsx
                            </span>
                            <span v-else>
                                Download Data .xlsx
                            </span>
                        </button>
                    </a>
                </div>
                <div class="col-sm-12 text-center wow fadeInUp" data-wow-delay="0.1s">&nbsp;</div>
                <div class="col-lg-12 col-xl-12 wow fadeInUp" data-wow-delay="0.3s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata1" style="font-size: 10px !important;">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="3">No</th>
                                    <th style="width: 250px;" rowspan="3">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Unit Pelaksana<br></br> / Paket
                                        </span>
                                        <span v-else>
                                            Implementation Unit<br></br> / Package
                                        </span>
                                    </th>
                                    <th style="width: 100px;" rowspan="3">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Status Pengadaan Paket
                                        </span>
                                        <span v-else>
                                            Package Procurement Status
                                        </span>
                                    </th>
                                    <th style="width: 150px;" :colspan="colspantahapan">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                            Proses Environmental Safeguard
                                        </span>
                                        <span v-else>
                                            Environmental Safeguard Process
                                        </span>
                                    </th>
                                </tr>
                                <tr>
                                    <template v-for="(datatahapanproses, uruttahapanproses) in tahapanproses"
                                        :key="uruttahapanproses">
                                        <th :colspan="datatahapanproses.colspan" style="width: 50px;">
                                            {{ datatahapanproses.nama }}
                                        </th>
                                    </template>
                                </tr>
                                <tr>
                                    <template v-for="(datatahapanproses, uruttahapanproses) in tahapanproses"
                                        :key="uruttahapanproses">
                                        <template
                                            v-for="(datatahapanprosesdetail, uruttahapanprosesdetail) in datatahapanproses.detail"
                                            :key="uruttahapanprosesdetail">
                                            <th style="width: 50px;">
                                                {{ datatahapanprosesdetail.nama }}
                                            </th>
                                        </template>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                    <tr>
                                        <td class="levelkomponen text-center">
                                            {{ urutlist + 1 }}
                                        </td>
                                        <td class="levelkomponen" :colspan="colspantahapan + 2">
                                            {{ datalist.PIU }}
                                        </td>
                                    </tr>
                                    <template v-for="(datasatker, urutsatker) in datalist.satker" :key="urutsatker">
                                        <tr>
                                            <td class="text-center levelsubkomponen">
                                                {{ urutlist + 1 }}.{{ urutsatker + 1 }}
                                            </td>
                                            <td class="levelsubkomponen" :colspan="colspantahapan + 2">
                                                {{ datasatker.nama_satker }}
                                            </td>
                                        </tr>
                                        <template v-for="(dataKegiatan, urutKegiatan) in datasatker.Kegiatan"
                                            :key="urutKegiatan">
                                            <tr>
                                                <td class="text-center">
                                                    {{ urutKegiatan + 1 }}
                                                </td>
                                                <td>
                                                    {{ dataKegiatan.Nama_Kegiatan }}
                                                </td>
                                                <td>
                                                    {{ dataKegiatan.Status_pekerjaan }}
                                                </td>
                                                <template
                                                    v-for="(datalistenvironmental, urutlistenvironmental) in dataKegiatan.environmental"
                                                    :key="urutlistenvironmental">
                                                    <template
                                                        v-for="(detailenvironmental, urutdetailenvironmental) in datalistenvironmental.detail"
                                                        :key="urutdetailenvironmental">
                                                        <td class="text-center"
                                                            :style="'background-color:' + detailenvironmental.class">
                                                            {{ detailenvironmental.progres }}
                                                        </td>
                                                    </template>
                                                </template>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            datapesan: '',
            sourcenya: '',
            colspantahapan: 0,
            datamaster: [],
            tahapanproses: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakenv-Environment?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitorenv-Reff?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.tahapanproses = [];
                        this.tahapanproses = Response.data.content.data;
                        this.colspantahapan = Response.data.content.colspan;
                        this.halamanloading = false;

                    }
                    else {
                        this.colspantahapan = 0;
                        this.tahapanproses = [];
                    }
                }
            ).catch(error => {
                this.colspantahapan = 0;
                this.tahapanproses = [];
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitorenv-Env?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = Response.data.content.data;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datamaster = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>